import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "email-sent"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "cancel-form" }
const _hoisted_7 = { class: "cancel-form__group--submit" }

import { computed, onBeforeMount, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import BasePopup from '@/components/ui/BasePopup.vue'
import { Mixpanel } from '@/analytics/mixpanel'
import { Sentry } from '@/services/sentry'
import { backend } from '@/services/backend'
import type { AccountStatus } from '@/models/interfaces'
import { ValidationState } from '@/helpers/form'
import FormError from '@/components/ui/FormError.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import AccountStatusInfo from '@/app/components/account/AccountStatusInfo.vue'
import { auth } from '@/services/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteAccountPopup',
  setup(__props, { expose: __expose }) {

const wait = useWait()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const accountStatus = ref<AccountStatus | null>(null)
const validation = ref(new ValidationState())
const deletionRequestComplete = ref(false)
const email = ref<string | null>(null)

onBeforeMount(() => {
  email.value = auth.getEmail()
})

async function show(): Promise<void> {
  popup.value?.show()

  if (accountStatus.value === null) {
    try {
      accountStatus.value = await backend.getAccountStatus()
    } catch (error) {
      // The error here is usually NetworkError or Timeout, but
      // we still capture all errors to Sentry to be aware if
      // error rate increases.
      Sentry.withScope(function (scope) {
        scope.setFingerprint(['account-status-loading-error'])
        Sentry.captureException(error)
      })
    }
  }
  Mixpanel.trackAccountDeleteClick()
}

function hide(): void {
  validation.value.reset()
  popup.value?.hide()
  Mixpanel.trackAccountDeleteCancel()
}

async function requestDeletion(event: Event): Promise<void> {
  event.preventDefault()
  validation.value.reset()
  try {
    wait.start('Deleting')
    await backend.requestAccountDeletion()
    deletionRequestComplete.value = true
    wait.end('Deleting')
  } catch (error) {
    wait.end('Deleting')
    Sentry.captureException(error)
    validation.value.showError(
      'delete_account',
      'Account deletion failed. Please try again.',
    )
  }
}

const popupTitle = computed(() => {
  return deletionRequestComplete.value
    ? 'Check Your Email to Delete'
    : 'Delete Account'
})

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: popupTitle.value
  }, {
    default: _withCtx(() => [
      (accountStatus.value === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (deletionRequestComplete.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " We've just sent an email to " + _toDisplayString(email.value) + " to confirm your deletion. Click the link in that email. Your account will not be deleted until you do so. If you don't see the email, check your spam folder. ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(AccountStatusInfo, { "account-status": accountStatus.value }, null, 8, ["account-status"]),
                  (accountStatus.value.subscription_status !== 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("form", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("a", {
                              class: "cancel-form__close-btn btns btns--largest btns--font-large btns--full",
                              onClick: hide
                            }, "Keep my account"),
                            _withDirectives((_openBlock(), _createElementBlock("a", {
                              class: "cancel-form__btn btns btns--largest btns--font-large btns--red btns--full",
                              onClick: requestDeletion
                            }, [
                              _createVNode(_component_v_wait, { for: "Deleting" }, {
                                waiting: _withCtx(() => [
                                  _cache[0] || (_cache[0] = _createTextVNode(" Deleting ", -1)),
                                  _createVNode(ButtonSpinner)
                                ]),
                                default: _withCtx(() => [
                                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Delete account", -1))
                                ]),
                                _: 1
                              })
                            ])), [
                              [_directive_wait, 'Deleting', "disabled"]
                            ])
                          ]),
                          _createVNode(FormError, {
                            errors: validation.value.errors,
                            field: "delete_account"
                          }, null, 8, ["errors"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})